import { Language, Links, ORDER } from './types';

const languages: Required<Language> = Object.freeze({
  'x-default': {
    langCode: '',
    order: ORDER.None,
  },
  'en-US': {
    langCode: '',
    order: ORDER.None,
  },
  'en-GB': {
    langCode: 'uk',
    order: ORDER.First,
  },
  de: {
    langCode: 'de',
    order: ORDER.First,
  },
  ru: {
    langCode: 'ru',
    order: ORDER.First, // we do business in Russia, but not in rubles.
  },
  es: {
    langCode: 'es',
    order: ORDER.First,
  },
  pt: {
    langCode: 'pt',
    order: ORDER.First,
  },
  nl: {
    langCode: 'nl',
    order: ORDER.First,
  },
  fr: {
    langCode: 'fr',
    order: ORDER.First,
  },
  it: {
    langCode: 'it',
    order: ORDER.First,
  },
  da: {
    langCode: 'da',
    order: ORDER.First,
  },
  sv: {
    langCode: 'sv',
    order: ORDER.First,
  },
  ja: {
    langCode: 'ja',
    order: ORDER.First,
  },
  ko: {
    langCode: 'ko',
    order: ORDER.First,
  },
  zh: {
    langCode: 'zh',
    order: ORDER.First,
  },
  tr: {
    langCode: 'tr',
    order: ORDER.First,
  },
  no: {
    langCode: 'no',
    order: ORDER.First,
  },
  fi: {
    langCode: 'fi',
    order: ORDER.First,
  },
});

export const LINKS: Links[] = [
  {
    lang: 'x-default',
  },
  {
    lang: 'en-US',
  },
  {
    lang: 'en-GB',
  },
  {
    lang: 'de',
  },
  {
    lang: 'ru',
  },
  {
    lang: 'es',
  },
  {
    lang: 'pt',
  },
  {
    lang: 'nl',
  },
  {
    lang: 'fr',
  },
  {
    lang: 'it',
  },
  {
    lang: 'da',
  },
  {
    lang: 'sv',
  },
  {
    lang: 'ja',
  },
  {
    lang: 'ko',
  },
  {
    lang: 'zh',
  },
  {
    lang: 'tr',
  },
  {
    lang: 'no',
  },
  {
    lang: 'fi',
  },
];

export function getLinks(domain: string, path: string): (Links | undefined)[] {
  const tempLinks = LINKS.map(({ lang }: Links): Links | undefined => {
    const language = languages[lang].langCode;
    if (languages[lang].order === ORDER.None) {
      return {
        lang,
        href: `https://www.${domain}.com${path}`,
      };
    }
    if (languages[lang].order === ORDER.First) {
      return {
        lang,
        href: `https://${language}.${domain}.com${path}`,
      };
    }
    if (languages[lang].order === ORDER.Last) {
      // legacy
      return {
        lang,
        href: `https://www.${domain}.${language}${path}`,
      };
    }
    return undefined;
  });
  return tempLinks.filter(links => links);
}
